import { Component, Input, OnInit, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { AlertController, IonContent, NavController, NavParams } from '@ionic/angular';

import { CustomerModel } from 'src/app/models/customer-model';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { birthdayValidator } from 'src/app/services/customFormValidators';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { ResponsibleGamingService } from 'src/app/services/responsible-gaming-service/responsible-gaming.service';
import { eMfaStatuses, UserSessionService } from 'src/app/services/user-session/user-session.service';
import { Navigator } from 'src/app/services/routing/navigator';
import { LogoutService } from 'src/app/services/logout/logout.service';
import { FormatPhoneNumberPipe } from 'src/app/pipes/format-phone-number/format-phone-number.pipe';
import { UniqueIDService } from 'src/app/services/unique-id/unique-id.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { RoutingService } from 'src/app/services/routing/routing.service';

enum UISwich {
  updateDOB = 'updateDOB',
  changePhoneNumber = 'changePhoneNumber',
  enterNewPhonePin = 'enterNewPhonePin',
}

@Component({
  selector: 'app-update-phone-number',
  templateUrl: './update-phone-number.component.html',
  styleUrls: ['./update-phone-number.component.scss'],
})
export class UpdatePhoneNumberComponent implements OnInit {
  @ViewChild(IonContent, { static: false }) content: IonContent;
  @Input() navigationFromSMSCodePage: boolean;
  @Input() callback;

  uiSwiches: UISwich | undefined;
  public error: any = null;

  showRGContactText = false;

  public infoForm: FormGroup;
  public dateOfBirthGroup: AbstractControl;
  public dateOfBirthYear: AbstractControl;
  public dateOfBirthDay: AbstractControl;
  public dateOfBirthMonth: AbstractControl;

  public updatephoneNumberForm: FormGroup;
  public phoneNumber: AbstractControl<string>;

  public customer: CustomerModel;
  public phoneUpdated: boolean;
  public legalAge: number;

  constructor(
    private authenticationService: AuthenticationService,
    private configService: ConfigService,
    private logoutService: LogoutService,
    private navCtrl: NavController,
    private navigator: Navigator,
    private responsibleGamingService: ResponsibleGamingService,
    private routing: RoutingService,
    private successMessageService: SuccessMessageService,
    private uniqueIDService: UniqueIDService,
    private userSessionService: UserSessionService,
  ) {
    this.successMessageService.clearMessage();
    this.userSessionService.getCustomer().subscribe((customer) => {
      if (customer) {
        this.customer = customer;
      }
    });
  }

  ionViewDidEnter() {
    this.successMessageService.clearMessage();
    if (this.navigationFromSMSCodePage) {
      this.uiSwiches = UISwich.updateDOB;
      this.showRGContactText = true;
    } else {
      this.showRGContactText = false;
    }
  }

  ngOnInit() {
    this.legalAge = this.configService.getConfig().FEATURE_LEGAL_AGE || 21;
    this.infoForm = new FormGroup({
      dateOfBirthGroup: new FormGroup(
        {
          dateOfBirthYear: new FormControl('', [
            Validators.required,
            Validators.pattern('^[0-9]+$'),
            Validators.minLength(4),
            Validators.maxLength(4),
          ]),
          dateOfBirthDay: new FormControl('', [
            Validators.required,
            Validators.pattern('^[0-9]+$'),
            Validators.minLength(2),
            Validators.maxLength(2),
          ]),
          dateOfBirthMonth: new FormControl('', [
            Validators.required,
            Validators.pattern('^[0-9]+$'),
            Validators.minLength(2),
            Validators.maxLength(2),
          ]),
          hiddenLegalAge: new FormControl(this.legalAge)
        },
        birthdayValidator
      ),
    });
    this.dateOfBirthGroup = this.infoForm.get('dateOfBirthGroup');
    this.dateOfBirthYear = this.dateOfBirthGroup.get('dateOfBirthYear');
    this.dateOfBirthDay = this.dateOfBirthGroup.get('dateOfBirthDay');
    this.dateOfBirthMonth = this.dateOfBirthGroup.get('dateOfBirthMonth');

    this.updatephoneNumberForm = new FormGroup({
      phoneNumber: new FormControl('', [
        Validators.required,
        Validators.pattern('^[0-9]+$'),
        Validators.minLength(10),
        Validators.maxLength(10),
      ]),
    });
    this.phoneNumber = this.updatephoneNumberForm.get('phoneNumber');
  }

  onContinue() {
    this.uiSwiches = UISwich.updateDOB;
  }

  onSubmitDOB() {
    const userMonth = this.dateOfBirthMonth.value;
    const userDay = this.dateOfBirthDay.value;
    const userYear = this.dateOfBirthYear.value;
    const dob = userYear + '-' + userMonth + '-' + userDay;
    this.authenticationService.validateDOB(dob).subscribe(
      (response) => {
        if (response.result == 1) {
          this.showChangePhoneNumberUI();
        }
      },
      (error) => {
        this.content.scrollToTop(10);
        switch (error.error_code) {
          case 'VALIDATE_BIRTHDATE_FAILED':
            error.setErrorMessage('Birth Date is invalid');
            break;
          default:
            error.setErrorMessage(
              'Sorry. We are unable to identify your date of birth. Please try again.'
            );
            break;
        }
        this.error = error;
      }
    );
  }

  sendPhoneCode() {
    const phone = this.phoneNumber.value;
    const customerId = this.customer.customerId;
    this.authenticationService.sendLoginCode(customerId, 'SMS', phone).subscribe(
      (response) => {
        if (response.result == 1) {
          this.showNewPhonePinUI();
          //   const formatedNumber = new FormatPhoneNumberPipe().transform(phone);
          //   this.alertController.create({
          //     subHeader: `We sent an SMS to your new phone number ${formatedNumber}, please enter code.`,
          //     buttons: ['OK'],
          //     cssClass: 'verifyPhoneCode',
          //     mode: 'ios'
          // }).then((alert) => { alert.present() });
        }
      },
      (error) => {
        this.content.scrollToTop(10);
        error.setErrorMessage(
          'There was an issue trying to send verification code to the phone number. Please contact customer support.'
        );
        this.error = error;
      }
    );
  }

  onUpdatedPhoneNumber() {
    this.userSessionService.refreshCustomer();
    this.phoneUpdated = true;
    this.successMessageService.setMessage('Your account had been successfully updated with your new phone.')
    if (this.navigationFromSMSCodePage) {
      this.error = null;
      const uniqueIDService = this.uniqueIDService;
      const mfcDeviceIdObservable = uniqueIDService.getMFADeviceIdObservable();
      if (mfcDeviceIdObservable) {
        mfcDeviceIdObservable.subscribe(deviceId => {
          uniqueIDService.setMFADeviceId(deviceId);
        }).unsubscribe();
      }
      this.userSessionService.setMFAStatus(eMfaStatuses.passed);
      if (this.callback) {
        this.navigator.dismiss();
        this.callback();
      } else {
        this.routing.defaultRoute();
      }
    }
    else {
      this.showChangePhoneNumberUI();
    }

  }

  closeModal = () => {
    if (this.navigationFromSMSCodePage && !this.phoneUpdated) {
      this.navigator.dismiss();
      this.logoutService.onLogout();
    } else {
      this.routing.defaultRoute();
    }
  };

  onValidatePinError(event) {
    this.error = event;
  }

  onPinVerifiedUserAction() {
    // on OK button clicked,
    this.closeModal();
  }

  onValidatePinSuccess() {
    // after ValidatePinSuccess then account will be updated automtically
    this.onUpdatedPhoneNumber();
  }

  showChangePhoneNumberUI() {
    this.error = null;
    this.uiSwiches = UISwich.changePhoneNumber;
  }

  showNewPhonePinUI(): void {
    this.error = null;
    this.uiSwiches = UISwich.enterNewPhonePin;
  }
}
